import React from "react"
import PropTypes from 'prop-types'

import {BLOCK_TYPE, DraftUtils, INLINE_STYLE} from "draftail"
import {EditorState, Modifier} from 'draft-js'
import {Stack} from 'immutable'
import ToolbarSizeControls from "./size-controls/size-controls"
import ToolbarButton from "./toolbar-button"
import {REDO_TYPE, UNDO_TYPE} from "../../api/constants"
import InlineOptions from "./inline-options/inline-options"
import InsertOptions from "./insert-options/insert-options"
import ButtonAddAttachmentControlButton from "../../../files/add-attachment-button/control-button"
import AddField from "../../../../gd-modules/common/add-column-new/add-field"

const debug = false
// const debug = "Toolbar"

export default class Toolbar extends React.Component {

    static propTypes = {
        controlsParams      : PropTypes.shape({
            leftChildren    : PropTypes.object,
            rightChildren   : PropTypes.object
        }),                                                // usd to add buttons externally

        showUndoRedo        : PropTypes.bool,

        onAddMention        : PropTypes.func,
        addLinkTask         : PropTypes.func,
        onLinkTask          : PropTypes.func,

        onAddAttachment     : PropTypes.func,   // id passed = show attach button + handle click

        addField            : PropTypes.object,   // used to add "Add field button" used in editor/formulas

        /*other props are passed from draftail*/
    };

    _insertText = (text = " @") => {
        const editorState = this.props.getEditorState();
        const selection = editorState.getSelection();

        //first remove selection if any
        const contentState = editorState.getCurrentContent();
        const contentStatesAfterDelete = Modifier.removeRange(contentState, selection, 'forward')
        const editorStateAfterDelete = EditorState.push(editorState, contentStatesAfterDelete, 'remove-range');

        //then add new text
        const updatedSelection = editorStateAfterDelete.getSelection();
        const contentStatesAfterInsert = Modifier.insertText(contentStatesAfterDelete, updatedSelection, text);
        const newEditorState = EditorState.push(editorStateAfterDelete, contentStatesAfterInsert, 'insert-characters');

        this.props.onChange(newEditorState);
    }

    addMention = () => {
        if (this.props.onAddMention) {
            this._insertText(" @");
            this.props.onAddMention();
        }
    }

    addLinkTask = () => {
        if (this.props.onLinkTask) {
            this._insertText(" /");
            this.props.onLinkTask();
        }
    }

    addLinkNote = () => {
        if (this.props.onLinkNote) {
            this._insertText(" /");
            this.props.onLinkNote();
        }
    }

    addHorizontalLine = () => {
        const editorState = this.props.getEditorState();
        const contentState = editorState.getCurrentContent();
        let undoStack = editorState.getUndoStack();

        const newEditorState = DraftUtils.addHorizontalRuleRemovingSelection(editorState);
        const currentContent = newEditorState.getCurrentContent();
        undoStack = undoStack.push(currentContent);

        const editorStateChanges = {
            currentContent,
            undoStack,
            redoStack: Stack(),
            lastChangeType: 'insert-characters',
            selection: contentState.getSelectionAfter(),
            forceSelection: false,
            inlineStyleOverride: editorState.getInlineStyleOverride()
        };

        const newEditorState2 = EditorState.set(editorState, editorStateChanges);

        this.props.onChange(newEditorState2);
    }

    render() {
        const leftChildren  = _.get(this.props, 'controlsParams.leftChildren', false)
        const rightChildren = _.get(this.props, 'controlsParams.rightChildren', false)

        debug && console.log(debug, 'render', leftChildren, rightChildren)

        return (
            <div className="gd-draftail-toolbar">

                {leftChildren}

                {this.props.addField &&
                    <div className="gd-draftail-toolbar-group">
                        <AddField manageColumnsConfig   = {this.props.addField.manageColumnsConfig}
                                  fields                = {this.props.addField.fields}
                                  showAdd               = {false}
                                  onToggleColumn        = {this.props.addField.onAddField}
                        >
                            <div className="ui5-control-button-with-label s-26 active">
                                <div className="ico i5-formula"/>
                                <div className="btn-label">Add field</div>
                            </div>
                        </AddField>

                    </div>
                }

                <ToolbarSizeControls {...this.props}/>

                {this.props.onAddAttachment && <div className="gd-draftail-toolbar-group">
                    <ButtonAddAttachmentControlButton onSelect={this.props.onAddAttachment} />
                </div>}


                <div className="gd-draftail-toolbar-group">
                    <ToolbarButton name={INLINE_STYLE.BOLD}             active={this.props.currentStyles.has(INLINE_STYLE.BOLD)}           gdIcon="editor-i5-bold"          onClick={this.props.toggleInlineStyle}     hint="Bold"/>
                    <ToolbarButton name={INLINE_STYLE.ITALIC}           active={this.props.currentStyles.has(INLINE_STYLE.ITALIC)}         gdIcon="editor-i5-italic"          onClick={this.props.toggleInlineStyle}     hint="Italic"/>
                    <ToolbarButton name={INLINE_STYLE.UNDERLINE}        active={this.props.currentStyles.has(INLINE_STYLE.UNDERLINE)}      gdIcon="editor-i5-underline"       onClick={this.props.toggleInlineStyle}     hint="Underline"/>
                    <ToolbarButton name={INLINE_STYLE.MARK}             active={this.props.currentStyles.has(INLINE_STYLE.MARK)}           gdIcon="i5-pen"       onClick={this.props.toggleInlineStyle}     hint="Mark"/>

                    <InlineOptions currentStyles={this.props.currentStyles} toggleInlineStyle={this.props.toggleInlineStyle}/>
                </div>

                <div className="gd-draftail-toolbar-group">
                    <InsertOptions onRequestSource={this.props.onRequestSource}
                                   addHorizontalLine={this.addHorizontalLine}
                                   addBR={this.props.addBR}
                                   addMention={this.addMention}
                                   addLinkTask={this.addLinkTask}
                                   addLinkNote={this.addLinkNote}/>
                </div>

                <div className="gd-draftail-toolbar-group">
                    <ToolbarButton name={BLOCK_TYPE.UNORDERED_LIST_ITEM}    active={this.props.currentBlock === BLOCK_TYPE.UNORDERED_LIST_ITEM}    gdIcon="editor-i5-bullet-list"    onClick={this.props.toggleBlockType}   hint="Unordered list"/>
                    <ToolbarButton name={BLOCK_TYPE.ORDERED_LIST_ITEM}      active={this.props.currentBlock === BLOCK_TYPE.ORDERED_LIST_ITEM}      gdIcon="editor-i5-numbered-list"    onClick={this.props.toggleBlockType}   hint="Ordered list"/>
                </div>

                <div className="gd-draftail-toolbar-group">
                    <ToolbarButton name={BLOCK_TYPE.BLOCKQUOTE}         active={this.props.currentBlock === BLOCK_TYPE.BLOCKQUOTE}         gdIcon="editor-i5-quote"   onClick={this.props.toggleBlockType}   hint="Blockquote"/>
                    <ToolbarButton name={BLOCK_TYPE.CODE}               active={this.props.currentBlock === BLOCK_TYPE.CODE}               gdIcon="editor-i5-code"    onClick={this.props.toggleBlockType}   hint="Block code"/>
                </div>

                {this.props.showUndoRedo &&
                <div className="gd-draftail-toolbar-group">
                    <ToolbarButton name={UNDO_TYPE} onClick={this.props.onUndoRedo} gdIcon="i5-undo"   hint="Undo"/>
                    <ToolbarButton name={REDO_TYPE} onClick={this.props.onUndoRedo} gdIcon="i5-redo1"   hint="Redo"/>
                </div>}

                {rightChildren}
            </div>
        )
    }
}